import React, { useEffect, useState } from "react";
import { faqs } from "../../data/data";
import FaqList from "./faqList";

const Faqs = ({ title }) => {
  const [col1Data, setCol1Data] = useState([]);
  const [col2Data, setCol2Data] = useState([]);

  useEffect(() => {
    const faqsLen = Math.ceil(faqs.length / 2);
    setCol1Data(faqs.slice(0, faqsLen));
    setCol2Data(faqs.slice(faqsLen));
  }, [faqs]);

  return (
    <div className="pt-[34px] pb-[50px] md:pb-[100px]">
      <div className="container">
        <div>
          <h2 className="text-center mb-[50px]">{title}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-[30px]">
            <dl className="">
              {col1Data.length > 0 && <FaqList faqList={col1Data} />}
            </dl>
            <dl className="">
              {col2Data.length > 0 && <FaqList faqList={col2Data} />}
            </dl>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
